import { List } from 'immutable';
import { chooseBenchPosition, retreat, retreatStart } from './actions';
import { setContextMenu } from '../ActiveGame/actions';
import { RETREAT } from '../ActiveGame/contextMenuTypes';
import { forcedEnergy } from './forcedEnergy';

/**
 * Starts a retreat, from the Retreat button or by dragging. With a retreat cost, the energy to discard is picked first
 * (RetreatContextMenu), unless the cost takes all of it (forcedEnergy); then the benched Pokémon to switch in, unless
 * it was already chosen (`benchPosition`, by dragging), in which case the retreat goes as soon as the energy is
 * settled.
 *
 * @param {List} energyAttachments the retreating Pokémon's energy cards
 * @returns {boolean} whether the retreat went straight to the server (nothing left to pick)
 */
export function startRetreat(dispatch, userId, retreatCost, energyAttachments, benchPosition = null) {
  const forced = forcedEnergy(energyAttachments, retreatCost);
  if (retreatCost > 0 && !forced) {
    dispatch(retreatStart(benchPosition));
    dispatch(setContextMenu(RETREAT, userId));
    return false;
  }
  dispatch(chooseBenchPosition(List(forced || [])));
  if (benchPosition === null) {
    return false;
  }
  dispatch(retreat(benchPosition));
  return true;
}
